import {InjectionToken} from '@angular/core';
import {ComponentType} from '@angular/cdk/typings/portal';

export const TIME_OUT_TOKEN: InjectionToken<ComponentType<any>> =
  new InjectionToken<ComponentType<any>>('TIME_OUT_TOKEN');
